import { IconButton, List, Toolbar } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { headerMenuStyles } from "./HeaderMenuStyles";
import { ReactComponent as Filter } from "icons/Filter.svg";
import { ReactComponent as ActiveFilter } from "icons/ActiveFilter.svg";
import { ReactComponent as Calendar } from "icons/Calendar.svg";
import HeaderMenuItem from "./HeaderMenuItem";
import clsx from "clsx";
import { LynxButton } from "components/LynxButton/LynxButton";
import { useStore } from "store/StoreConfigs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { observer } from "mobx-react";
import moment from "moment";

export default observer(function HeaderMenu() {
    const { identityStore, commonStore, filtersStore } = useStore();
    const [calendarOpen, setCalendarOpen] = useState(false);

    const classes = headerMenuStyles();
    const [selectedIndex, setSelectedIndex] = useState(4);

    useEffect(() => {
        setSelectedIndex(4);
    }, [identityStore.currentCustomerId]);

    const handleSettingsClick = (
        _event: React.MouseEvent<HTMLDivElement, MouseEvent>,
        index: number,
        method: () => void
    ) => {
        if (selectedIndex !== index) {
            setSelectedIndex(index);
            method();
        } else {
            setSelectedIndex(selectedIndex);
            method();
        }
    };
    const setLast24Hours = () => {
        filtersStore.setDateRange([
            new Date(moment().subtract(1, "d").format("YYYY-MM-DD HH:mm:ss")),
            new Date(moment().format("YYYY-MM-DD HH:mm:ss")),
        ]);
    };
    const setLast48Hours = () => {
        filtersStore.setDateRange([
            new Date(moment().subtract(2, "d").format("YYYY-MM-DD HH:mm:ss")),
            new Date(moment().format("YYYY-MM-DD HH:mm:ss")),
        ]);
    };
    const setLast7Days = () => {
        filtersStore.setDateRange([
            new Date(moment().subtract(7, "d").format("YYYY-MM-DD HH:mm:ss")),
            new Date(moment().format("YYYY-MM-DD HH:mm:ss")),
        ]);
    };
    const setLast30Days = () => {
        filtersStore.setDateRange([
            new Date(moment().subtract(30, "d").format("YYYY-MM-DD HH:mm:ss")),
            new Date(moment().format("YYYY-MM-DD HH:mm:ss")),
        ]);
    };

    const setLast90Days = () => {
        filtersStore.setDateRange([
            new Date(moment().subtract(90, "d").format("YYYY-MM-DD HH:mm:ss")),
            new Date(moment().format("YYYY-MM-DD HH:mm:ss")),
        ]);
    };
    const resetAllFilters = () => {
        setSelectedIndex(4);
        setLast90Days();
    };

    const handleCloseFilter = () => {
        commonStore.setFiltersClose();
    };

    const Text = [
        { title: "Last 24h", onClickMethod: setLast24Hours },
        { title: "Last 48h", onClickMethod: setLast48Hours },
        { title: "Last 7d", onClickMethod: setLast7Days },
        { title: "Last 30d", onClickMethod: setLast30Days },
        { title: "Last 90d", onClickMethod: setLast90Days },
    ];

    return (
        <div className={classes.grow}>
            <Toolbar className={classes.main}>
                {commonStore.isFilterOpen ? (
                    <IconButton
                        onClick={handleCloseFilter}
                        className={clsx({
                            [classes.openFilterBtn]: commonStore.isFilterOpen,
                        })}
                    >
                        <ActiveFilter />
                    </IconButton>
                ) : (
                    <IconButton
                        onClick={commonStore.setFiltersOpen}
                        className={clsx({
                            [classes.filterBtn]: !commonStore.isFilterOpen,
                        })}
                    >
                        <Filter />
                    </IconButton>
                )}
                <div className={classes.datePickerWrapper}>
                    <DatePicker
                        className={classes.picker}
                        selectsRange={true}
                        startDate={filtersStore.startDate}
                        endDate={filtersStore.endDate}
                        onChange={(update: any) => {
                            // (update[1] && update[0]) <= new Date() for disable future dates
                            // add throw exception
                            if (update[0] <= new Date()) filtersStore.setDateRange(update);
                            setSelectedIndex(-1);
                        }}
                        placeholderText="Select date range"
                        dateFormat="MM/dd/yy"
                        open={calendarOpen}
                        disabledKeyboardNavigation
                        onInputClick={() => {
                            setCalendarOpen(true);
                        }}
                        onClickOutside={() => {
                            setCalendarOpen(false);
                        }}
                        onSelect={() => {
                            if (filtersStore.endDate != null) {
                                setCalendarOpen(false);
                            }
                        }}
                    />
                    <Calendar
                        style={{
                            position: "absolute",
                            left: 270,
                            top: 15,
                            cursor: "pointer",
                        }}
                        onClick={() => {
                            setCalendarOpen(true);
                        }}
                    />
                </div>

                <List>
                    {Text.map((item, index) => (
                        <HeaderMenuItem
                            selectedState={selectedIndex === index}
                            listItemStyles={classes.listItemDisplay}
                            listItemTextStyles={clsx({
                                [classes.selectedText]: selectedIndex === index,
                                [classes.Unselected]: !(selectedIndex === index),
                            })}
                            key={index}
                            text={item.title}
                            onClickFunc={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
                                handleSettingsClick(event, index, item.onClickMethod)
                            }
                        ></HeaderMenuItem>
                    ))}
                </List>
                <div className={classes.grow} />
                <LynxButton className={classes.button} size="medium" responsive={false} onClick={resetAllFilters}>
                    Reset Filters
                </LynxButton>
            </Toolbar>
        </div>
    );
});
